// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/popover/index.css
// module id = 447
// module chunks = 32